
import { formatText } from '../lib/utils';
import { motion } from 'framer-motion';

import img1 from '../assets/gallery/1.webp';
import img2 from '../assets/gallery/2.webp';
import img3 from '../assets/gallery/3.webp';
import img4 from '../assets/gallery/4.webp';
import img5 from '../assets/gallery/5.webp';
import img6 from '../assets/gallery/6.webp';
import img7 from '../assets/gallery/7.webp';
import img8 from '../assets/gallery/8.webp';
import img9 from '../assets/gallery/9.webp';

const WhyWe = () => {
    const images = [
        img1, img2, img3, img4, img5, img6, img7, img8, img9
    ];

    return (
        <motion.section
            id="why-we"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex flex-col border-b-[1px] border-t-[0px] border-r-[0px] border-l-[0px] border-[#525252] md:pt-[6rem] sm:pt-[5rem] pt-[5rem] lg:pt-[120px] md:pb-[6rem] sm:pb-[5rem] pb-[5rem] lg:pb-[120px] xl:w-[100%] xl:max-w-[auto] w-[100%] max-w-[auto] ml-[auto] mr-[auto]"
        >
            <div className="flex flex-col w-[100%] max-w-[1280px] mr-[auto] ml-[auto] md:pr-[4rem] sm:pr-[4rem] pr-[1.5rem] lg:pr-[32px] md:pl-[4rem] sm:pl-[4rem] pl-[1.5rem] lg:pl-[32px] md:gap-[4rem] sm:gap-[4rem] gap-[3rem] lg:gap-[72px] 2xl:max-w-[1536px]">
                <div className="flex flex-col sm:flex-row gap-[2rem] sm:gap-[12px] items-start sm:items-start">
                    <h2 className="font-semibold block text-[36px] sm:text-[48px] leading-[1.25em] w-[100%] sm:w-[50%]">{formatText("Zobacz nasze przykładowe realizacje grafik i video reklamowych")}</h2>
                </div>
                <div className="sm:flex-row flex-col md:flex-col sm:flex-wrap flex-wrap md:flex-nowrap grid md:grid-cols-2 sm:grid-cols-2 grid-cols-1 lg:grid-cols-3 grid-rows-2 gap-[12px]">
                    {images.map((src, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ delay: index * 0.1 }}
                            className="w-[100%] border-[1px] border-[#525252] bg-[#171717] hover:bg-white text-white hover:text-black transition-colors duration-300 pt-[1rem] pl-[1rem] pr-[1rem] pb-[1rem] space-y-[1rem] rounded-[6px] group"
                        >
                            <img src={src} className="h-[auto] max-w-[100%] rounded-[4px] w-[100%]" alt={`Gallery image ${index + 1}`} />
                            <div className="flex flex-row gap-[12px]">
                                <div className="w-[100%] flex justify-between pt-[1rem] pb-[1rem]">
                                    <div className="flex gap-[1rem]">
                                        <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-[auto] cursor-pointer">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-heart-icon lucide-heart">
                                                <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                                            </svg>
                                        </motion.i>
                                        <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-[auto] cursor-pointer">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-message-circle-icon lucide-message-circle">
                                                <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>
                                            </svg>
                                        </motion.i>
                                        <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-[auto] cursor-pointer">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-send-icon lucide-send">
                                                <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                                                <path d="m21.854 2.147-10.94 10.939"></path>
                                            </svg>
                                        </motion.i>
                                    </div>
                                    <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-auto cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-bookmark-icon lucide-bookmark">
                                            <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
                                        </svg>
                                    </motion.i>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </motion.section>
    );
};

export default WhyWe;
